import Vue from 'vue'
import App from '@/App.vue'
import { i18n } from '@/i18n'

import router from '@/router'
import '@/axios'
import store from '@/store'
import '@/registerServiceWorker'

/*
 * --------------
 * Styling
 * --------------
 */

import '@/assets/icons/_index.js'
import '@/styles/app.scss'

import lodash from 'lodash'
import VueLodash from 'vue-lodash'
Vue.use(VueLodash, { lodash })

import vmodal from 'vue-js-modal'
Vue.use(vmodal)

/*
| ---------------
| Base Sts plugins
| ---------------
| Setup global plugins used in R2s
| VeeValidate, Vue-moment
*/
// Validate
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)

const moment = require('moment')
moment.locale(i18n.locale.substring(0, 2))
Vue.use(require('vue-moment'), { moment })

import VueMasonry from 'vue-masonry-css'
Vue.use(VueMasonry)

// TODO: Extract
import Toasted from 'vue-toasted'

Vue.use(Toasted)
Vue.toasted.register(
    'info',
    payload => {
        let html = '<div class="content">'
        if (payload.title) html += '<p class="title">' + payload.title + '</p>'
        if (payload.description) html += '<p class="description">' + payload.description + '</p>'
        if (payload.cta)
            html += '<a class="cta" href="' + payload.cta_link + '">' + payload.cta + '</a>'
        html += '</div>'
        return html
    },
    {
        position: 'bottom-right',
        duration: 5000,
        theme: 'outline',
        iconPack: 'callback',
        icon: el => {
            el.innerHTML =
                '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 18 24"><g><g><path fill="#0f3261" d="M17.25 8.25c0 2.08-.771 3.977-2.041 5.428-.78.89-2.004 2.755-2.458 4.32V18h-2.25v-.005c0-.227.036-.453.104-.67a14.814 14.814 0 0 1 2.911-5.13A5.982 5.982 0 0 0 15 8.25c0-3.308-2.692-6-6-6-3.2 0-6.007 2.548-5.998 6a5.981 5.981 0 0 0 1.482 3.944C6.33 14.3 7.136 16.5 7.398 17.334c.067.215.1.437.101.66V18H5.25v-.003c-.454-1.564-1.677-3.43-2.457-4.32A8.204 8.204 0 0 1 .75 8.25C.75 3.89 4.206 0 9 0a8.25 8.25 0 0 1 8.25 8.25zm-12 11.25h7.5l-.003 2.024a.754.754 0 0 1-.126.414l-1.149 1.727a.75.75 0 0 1-.624.335H7.152a.75.75 0 0 1-.625-.335l-1.149-1.727a.745.745 0 0 1-.125-.414zm4.5-15a.75.75 0 0 1-.75.75c-1.654 0-3 1.345-3 3a.75.75 0 1 1-1.5 0c0-2.482 2.018-4.5 4.5-4.5a.75.75 0 0 1 .75.75z"/></g></g></svg>'
            return el
        },
    }
)

Vue.config.productionTip = false

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
)

router.onReady(() => {
    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r
            ; (i[r] =
                i[r] ||
                function () {
                    (i[r].q = i[r].q || []).push(arguments)
                }),
                (i[r].l = 1 * new Date())
            ; (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0])
        a.async = 1
        a.src = g
        m.parentNode.insertBefore(a, m)
    })(window, document, 'script', `https://www.google-analytics.com/analytics.js`, 'ga')

    ga('create', 'UA-92813904-1', 'auto')

    // Prevent any hits from being sent to Google Analytics
    if (process.env.NODE_ENV === 'production') {
        ga('set', 'sendHitTask', null)
    }

    router.afterEach((to, from) => {
        ga('set', 'page', to.fullPath)
        ga('send', 'pageview')
    })
})

let vInstance = new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
    data() {
        return {
            sizer: 'sm'
        }
    },
    mounted() {
        let self = this;
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
        self.calcSizer()

        window.addEventListener('resize', () => {
            let vh = window.innerHeight * 0.01
            document.documentElement.style.setProperty('--vh', `${vh}px`)
            self.calcSizer()
        })
        window.addEventListener("orientationchange", function () {
            let vh = window.innerHeight * 0.01
            document.documentElement.style.setProperty('--vh', `${vh}px`)
            self.calcSizer()
        });
    },

    methods: {
        calcSizer() {
            if (window.innerWidth >= 1024) this.sizer = 'lg'
            else if (window.innerWidth >= 576) this.sizer = 'md'
            else this.sizer = 'sm'
        }
    },
    computed: {
        aspect() {
            return window.innerHeight <= 705 ? 'sm' : 'lg'
        },
    },
    created() {
        (function () {
            window.ybug_settings = {
                "id": "twz6srhgqz"
            };
            var ybug = document.createElement('script');
            ybug.type = 'text/javascript';
            ybug.async = true;
            ybug.src = 'https://ybug.io/api/v1/button/' + window.ybug_settings.id + '.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(ybug, s);
        })();

        if (process.env.NODE_ENV === 'production') {
            (function (h, o, t, j, a, r) {
                h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
                h._hjSettings = { hjid: 1586649, hjsv: 6 };
                a = o.getElementsByTagName('head')[0];
                r = o.createElement('script'); r.async = 1;
                r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                a.appendChild(r);
            })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
        }
    }
}).$mount('#app')

VeeValidate.Validator.extend(
    'step',
    {
        validate: (value, { step }) => {
            if (typeof value !== 'string') {
                return false
            }

            let stepNumber = Number(step)
            if (typeof stepNumber !== 'number') {
                return false
            }

            let seperatorIndex = value.indexOf(':')
            let hours = value.substring(0, seperatorIndex)
            let minutes = value.substring(seperatorIndex + 1)

            return (hours * 3600 + minutes * 60) % stepNumber === 0
        },
        getMessage: (field, args) => {
            return vInstance._i18n.t('errors.validation.step', {
                field: field,
                step: Number(args[0] / 60),
            })
        },
    },
    { paramNames: ['step'] }
)

VeeValidate.Validator.extend(
    'time_required',
    {
        validate: value => {
            if (!value || !value.HH || !value.mm) {
                return false;
            }
            return true;
        },
        getMessage: field => {
            return vInstance._i18n.t('errors.validation.this_required', {
                0: field
            })
        },
    },
)

VeeValidate.Validator.extend(
    'time_gte',
    {
        validate: (value, [minutes]) => {
            return ((parseInt(value.HH) * 60 + parseInt(value.mm)) >= minutes)
        },
        getMessage: (field, [minutes]) => {
            return vInstance._i18n.tc('errors.validation.time_gte', minutes, {
                n: minutes
            })
        },
    },
)

console.log('test if cache is enabled')